import React from 'react';
import classNames from 'classnames';
import { ImageModel } from '@/types';
// @ts-expect-error: Unreachable code error
import { AzureMP } from 'react-azure-mp';

type EmbeddedMediaElementModel = {
  coverImage?: ImageModel;
  videoEmbedCode?: string;
  summary?: string;
  title?: string;
  videoUrl?: string;
  codeId?: string;
  moduleName?: string;
  autoplay?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const EmbeddedMediaElement = ({
  coverImage,
  videoEmbedCode,
  videoUrl,
  className,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moduleName,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  codeId,
  autoplay,
  summary,
  title,
  ...props
}: EmbeddedMediaElementModel) => {
  if (!videoEmbedCode) {
    return null;
  }
  let contanerClass = '';
  let videoType: string = '';
  if (videoUrl && videoUrl.length > 0) {
    videoType = 'blob';
  } else if (videoEmbedCode?.includes('windows.net')) {
    videoType = 'azure';
  } else if (videoEmbedCode?.includes('tiktok')) {
    videoType = 'tiktok';
  } else if (videoEmbedCode?.includes('youtube')) {
    videoType = 'youtube';
    contanerClass = 'aspect-video';
  } else if (videoEmbedCode?.includes('vimeo')) {
    videoType = 'vimeo';
    contanerClass = 'aspect-video';
  }

  let videoElement: React.ReactNode = null;
  if (videoType === 'blob') {
    videoElement = (
      <video
        autoPlay={autoplay}
        controlsList="nodownload"
        preload="auto"
        poster={coverImage?.imageUrl}
        className="video-js embed-video amp-big-play-centered azure-height"
        controls
        src={videoUrl}
      />
    );
  } else if (videoType === 'azure') {
    videoElement = (
      <AzureMP
        skin="amp-default"
        options={{ controls: autoplay, autoplay: autoplay, poster: coverImage?.imageUrl }}
        src={[
          {
            src: videoEmbedCode,
            type: 'application/vnd.ms-sstr+xml',
          },
        ]}
      />
    );
  } else {
    videoElement = (
      <div
        className="relative h-full w-full [&_iframe]:h-full [&_iframe]:w-full [&_p]:hidden"
        dangerouslySetInnerHTML={{ __html: videoEmbedCode }}
      />
    );
  }
  return (
    <div className={classNames('embedded-media', videoType, className)} {...props}>
      <div className={contanerClass}>{videoElement}</div>
      {(summary || title) && (
        <div className="border-b border-b-[#ccc] py-4">
          {title && <div className="text-base font-bold">{title}</div>}
          {summary && <div className="mt-3 text-sm">{summary}</div>}
        </div>
      )}
    </div>
  );
};

export default EmbeddedMediaElement;
